import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import VideoCard from '@/components/feature/VideoCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getVideosByCategory } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const videos = slug ? getVideosByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <SEOHead
          title="分类未找到 - 国产精品视频精选推荐平台"
          description="抱歉，您访问的视频分类不存在。"
          keywords="国产精品视频"
          canonicalPath={`/category/${slug || ''}`}
        />
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-bold text-foreground-950 font-heading mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 whitespace-nowrap">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 国产精品${category.name}视频精选推荐`}
        description={`国产精品${category.name}频道，${category.description}。精选高品质国产${category.name}内容，为您提供流畅清晰的观看体验。`}
        keywords={`国产精品视频,国产${category.name}视频,国产精品${category.name},国产原创${category.name}视频`}
        canonicalPath={`/category/${slug}`}
      />

      <Navbar />

      <main className="pt-16">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: category.name },
              ]}
            />

            <div className="mt-6 mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
                {category.name}
              </h1>
              <p className="text-foreground-500 text-sm max-w-2xl">{category.description}</p>
            </div>

            <div className="flex items-center gap-2 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {videos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {videos.map((video) => (
                  <VideoCard key={video.id} video={video} variant="compact" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无该分类的视频内容</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}